// import React, { useState } from 'react';
// import { Dialog, Transition } from '@headlessui/react';
// import ReactQuill from 'react-quill';
// import 'react-quill/dist/quill.snow.css';

// const EmailTemplates = () => {
// const [editorContent, setEditorContent] = useState('');
// const [templateName, setTemplateName] = useState('');
// const [currentTemplate, setCurrentTemplate] = useState(null);
// const [isOpen, setIsOpen] = useState(false);
// const [templates, setTemplates] = useState([]);
// const [isSourceMode, setIsSourceMode] = useState(false);

//     const handleCancel = () => {
//         setIsOpen(false);
//         setCurrentTemplate(null);
//         setTemplateName('');
//         setEditorContent('');
//     };

// const handleAddOrUpdate = (e) => {
//     e.preventDefault();
//     const newTemplate = { name: templateName, content: editorContent };
//     if (currentTemplate !== null) {
//         const updatedTemplates = templates.map((template, index) =>
//             index === currentTemplate ? newTemplate : template
//         );
//         setTemplates(updatedTemplates);
//     } else {
//         setTemplates([...templates, newTemplate]);
//     }
//     setIsOpen(false);
//     setCurrentTemplate(null);
//     setTemplateName('');
//     setEditorContent('');
// };

//     const handleEdit = (index) => {
//         setCurrentTemplate(index);
//         setTemplateName(templates[index].name);
//         setEditorContent(templates[index].content);
//         setIsOpen(true);
//     };

//     const toggleSourceMode = () => {
//         setIsSourceMode(!isSourceMode);
//     };

// const modules = {
//     toolbar: [
//         [{ 'header': '1'}, {'header': '2'}, { 'font': [] }],
//         [{size: []}],
//         ['bold', 'italic', 'underline', 'strike', 'blockquote'],
//         [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
//         ['link', 'image', 'video'],
//         ['clean'],
//         [{ 'align': [] }]
//     ],
// };

//     return (
//         <div>
//             <div>
//                 <h1 className="text-2xl font-bold mb-4">Email Templates</h1>
//                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
//                     {templates.map((template, index) => (
//                         <div key={index} className="bg-white p-4 rounded shadow">
//                             <h2 className="text-xl font-semibold">{template.name}</h2>
//                             <button
//                                 onClick={() => handleEdit(index)}
//                                 className="mt-2 px-4 py-2 bg-blue-500 text-white rounded"
//                             >
//                                 Edit
//                             </button>
//                         </div>
//                     ))}
//                 </div>
//                 <button
//                     onClick={() => setIsOpen(true)}
//                     className="mt-4 px-4 py-2 bg-green-500 text-white rounded"
//                 >
//                     Add Template
//                 </button>
//             </div>

//             <Transition show={isOpen}>
//                 <Dialog onClose={handleCancel}>
//                     <div className="fixed inset-0 flex items-center justify-center">
//                         <div className="bg-white p-6 rounded shadow-lg max-w-3xl w-full">
//                             <Transition.Child>
//                                 <Dialog.Panel>
//                                     <div>
//                                         <form onSubmit={handleAddOrUpdate}>
//                                             <div>
//                                                 <label className="block text-sm font-medium text-gray-700">
//                                                     Template Name
//                                                 </label>
//                                                 <input
//                                                     type="text"
//                                                     value={templateName}
//                                                     onChange={(e) => setTemplateName(e.target.value)}
//                                                     className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
//                                                     required
//                                                 />
//                                             </div>
//                                             <div className="mt-4">
//                                                 <label className="block text-sm font-medium text-gray-700">
//                                                     Content
//                                                 </label>
//                                                 <div className="h-64 overflow-y-auto">
//                                                     {isSourceMode ? (
//                                                         <textarea
//                                                             value={editorContent}
//                                                             onChange={(e) => setEditorContent(e.target.value)}
//                                                             className="w-full h-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
//                                                         />
//                                                     ) : (
//                                                         <ReactQuill
//                                                             value={editorContent}
//                                                             onChange={setEditorContent}
//                                                             theme="snow"
//                                                             modules={modules}
//                                                         />
//                                                     )}
//                                                 </div>
//                                             </div>
//                                             <div className="mt-4 flex justify-end space-x-2">
//                                                 <button
//                                                     type="button"
//                                                     className="px-4 py-2 bg-yellow-500 text-white rounded"
//                                                     onClick={toggleSourceMode}
//                                                 >
//                                                     {isSourceMode ? "View Mode" : "Source Mode"}
//                                                 </button>
//                                                 <button
//                                                     type="submit"
//                                                     className="px-4 py-2 bg-blue-500 text-white rounded"
//                                                 >
//                                                     {currentTemplate !== null ? "Update" : "Add"}
//                                                 </button>
//                                                 <button
//                                                     type="button"
//                                                     className="px-4 py-2 bg-gray-500 text-white rounded"
//                                                     onClick={handleCancel}
//                                                 >
//                                                     Cancel
//                                                 </button>
//                                             </div>
//                                         </form>
//                                     </div>
//                                 </Dialog.Panel>
//                             </Transition.Child>
//                         </div>
//                     </div>
//                 </Dialog>
//             </Transition>
//         </div>
//     );
// };

// export default EmailTemplates;

import { useEffect, useMemo, useState, Fragment, useRef } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { ChevronDownIcon, ChevronUpIcon, MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { HalfRow } from '../../components';
import FormButton from '../../components/formElements/FormButton';
import { FormFieldsContainer, WhiteCardContainer } from '../../components';
import Loader from '../../components/Loader/Loader';
import { ProfileFormHeader } from '../Users/components/ProfileFormHeader';
import { emailTemplatesS } from '../../services/EmailTemplates';
import { useTable, usePagination, useSortBy, useFilters, useGlobalFilter, useAsyncDebounce } from 'react-table';
import 'react-quill/dist/quill.snow.css';
import JoditEditor from 'jodit-react';
const EmailTemplates = () => {
    const [isFormOpen, setIsFormOpen] = useState(false);
    const [loading, setLoading] = useState(true);

    const [dialog, setDialog] = useState({ isOpen: false, mode: '' });
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [editorContent, setEditorContent] = useState('');
    const [templateName, setTemplateName] = useState('');
    const [templateSubject, setTemplateSubject] = useState('');
    const [currentTemplate, setCurrentTemplate] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [templates, setTemplates] = useState([]);
    const [isSourceMode, setIsSourceMode] = useState(false);
    const [error, setError] = useState('');
    const editorRef = useRef(null);
    const [editMode, setEditMode] = useState(false);
    const [templateNameError, setTemplateNameError] = useState('');
    const [templateSubjectError, setTemplateSubjectError] = useState('');
    const openModal = () => setIsOpen(true);
    const closeModal = () => {
        setIsOpen(false);
        setError('');
    };
    const config = {
        toolbarSticky: false,
        toolbar: true,
        statusbar: false,
        height: 500,
        showCharsCount: false,
        showWordsCount: false,
        showXPathInStatusbar: false,
        showCharsCounter: false,
        showWordsCounter: false,
        toolbarAdaptive: false,
        toolbarStickyOffset: 0
    };
    const handleCancel = () => {
        setIsOpen(false);
        setCurrentTemplate(null);
        setTemplateName('');
        setTemplateSubject('');
        setEditorContent('');
        setTemplateNameError('');
        setTemplateSubjectError('');
    };

    const handleAddOrUpdate = async (e) => {
        e.preventDefault();

        if (!templateName || templateName.trim() === '') {
            setTemplateNameError('El nombre de la plantilla es obligatorio');
            return;
        }
        if (templateName.length < 3) {
            setTemplateNameError('El nombre debe tener al menos 3 caracteres');
            return;
        }
        if (!templateSubject || templateSubject.trim() === '') {
            setTemplateSubjectError('El asunto del correo es obligatorio');
            return;
        }
        if (templateSubject.length < 3) {
            setTemplateSubjectError('El asunto debe tener al menos 3 caracteres');
            return;
        }
        setTemplateNameError('');
        setTemplateSubjectError('');

        const newTemplate = { title: templateName, subject: templateSubject, content: editorContent };
        if (currentTemplate !== null) {
            const response = await emailTemplatesS.edit({ id: currentTemplate.id, ...newTemplate });
            if (response.data) {
                const updatedTemplates = templates.map((template, index) =>
                    template.id === currentTemplate.id ? { ...newTemplate, id: currentTemplate.id } : template
                );
                setTemplates(updatedTemplates);
            }
        } else {
            const response = await emailTemplatesS.add(newTemplate);
            if (response.data) {
                setTemplates([response.data, ...templates]);
            }
        }
        setIsOpen(false);
        setCurrentTemplate(null);
        setTemplateName('');
        setEditorContent('');
    };

    const toggleSourceMode = () => {
        setIsSourceMode(!isSourceMode);
    };

    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     const { title, content } = templates;

    //     const formData = new FormData();
    //     formData.append('title', title);
    //     formData.append('content', content);
    //     if (editMode) {
    //         formData.append('id', templates.id);
    //     }

    //     try {
    //         if (editMode) {
    //             await Blog.edit(formData);
    //         } else {
    //             await Blog.add(formData);
    //         }
    //         closeModal();
    //         setEditMode(false);
    //         // setBlog({ title: '', author: '', content: '', image: null });
    //         getBlogs();
    //     } catch (error) {
    //         console.error('Error adding blog:', error);
    //         setError('Failed to add blog. Please try again.');
    //     }
    // };

    useEffect(() => {
        getTemplates();
    }, []);

    const getTemplates = () => {
        emailTemplatesS.get().then((res) => {
            // setBlogs(res.data);
            const sortedTemplates = res.data.sort((a, b) => b.id - a.id);
            setTemplates(sortedTemplates);

            setLoading(false);
        });
    };

    const _handleClick = (selectedItem, mode) => {
        if (mode === 'edit') {
            console.log(selectedItem, 'selectedItem');
            handleEditClick(selectedItem);
            setIsSourceMode(false);
        } else {
            setEditMode(false);
            // setBlog({ title: '', author: '', content: '', image: null });
            openModal(mode);
        }
    };

    const handleEditClick = (template) => {
        setEditMode(true);
        setTemplateName(template.title);
        setTemplateSubject(template.subject || '');
        setEditorContent(template.content);
        setCurrentTemplate(template);
        // setImagePreview(image);
        openModal('edit');
    };

    let templatesTable = useMemo(() => {
        return templates.map((item) => {
            return {
                col1: item.title,
                col2: (
                    <div className="flex gap-2">
                        <div
                            onClick={() => _handleClick(item, 'edit')}
                            className="text-dl-primary-900 hover:text-dl-accent cursor-pointer"
                        >
                            Editar
                            <span className="sr-only"></span>
                        </div>
                    </div>
                )
            };
        });
    }, [templates]);

    const manualColumns = useMemo(() => {
        return [
            {
                Header: 'Título',
                accessor: 'col1',
                width: 700,
                Cell: ({ value }) => <div className="max-w-[700px] truncate">{value}</div>
            },
            { Header: 'Acciones', accessor: 'col2' }
        ];
    }, []);

    const tableInstance = useTable(
        { columns: manualColumns, data: templatesTable },
        useFilters,
        useGlobalFilter,
        useSortBy,
        usePagination
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        data,
        columns,
        state,
        preGlobalFilteredRows,
        setGlobalFilter,
        page,
        canPreviousPage,
        canNextPage,
        pageCount,
        nextPage,
        previousPage,
        setPageSize
    } = tableInstance;

    const [value, setValue] = useState(state.globalFilter);
    const onChange = useAsyncDebounce((value) => {
        setGlobalFilter(value || undefined);
    }, 200);

    if (loading) {
        return <Loader />;
    }

    const modules = {
        toolbar: [
            [{ header: '1' }, { header: '2' }, { font: [] }],
            [{ size: [] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
            ['link', 'image', 'video'],
            ['clean'],
            [{ align: [] }]
        ],
        clipboard: {
            matchVisual: false
        }
    };

    return (
        <WhiteCardContainer>
            <div className="ml-2">
                <FormFieldsContainer>
                    <ProfileFormHeader title="Plantillas de correo electrónico" />
                    <div className="flex-row-reverse">
                        <FormButton
                            type="button"
                            label="Agregar nueva plantilla de correo electrónico"
                            onClick={openModal}
                        />
                    </div>
                </FormFieldsContainer>
            </div>

            <div className="px-4 sm:px-6 lg:px-8 mb-10">
                <div className="flex flex-col">
                    <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                            <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
                                <table {...getTableProps()} className="min-w-full divide-y divide-gray-300">
                                    <thead className="bg-gray-50">
                                        {headerGroups.map((headerGroup) => (
                                            <tr {...headerGroup.getHeaderGroupProps()}>
                                                {headerGroup.headers.map((column) => (
                                                    <th
                                                        {...column.getHeaderProps(column.getSortByToggleProps())}
                                                        style={{ width: column.width }} // 👈 Apply style
                                                        className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                                                    >
                                                        <div className="inline-flex items-center">
                                                            {column.render('Header')}
                                                            <span>
                                                                {column.isSorted ? (
                                                                    column.isSortedDesc ? (
                                                                        <ChevronUpIcon className="h-5 w-5" />
                                                                    ) : (
                                                                        <ChevronDownIcon className="h-5 w-5" />
                                                                    )
                                                                ) : (
                                                                    ''
                                                                )}
                                                            </span>
                                                        </div>
                                                    </th>
                                                ))}
                                            </tr>
                                        ))}
                                    </thead>
                                    <tbody className="divide-y divide-gray-200 bg-white" {...getTableBodyProps()}>
                                        {page.map((row) => {
                                            prepareRow(row);
                                            return (
                                                <tr {...row.getRowProps()}>
                                                    {row.cells.map((cell) => {
                                                        return (
                                                            <td
                                                                {...cell.getCellProps({
                                                                    style: { width: cell.column.width } // 👈 Apply style
                                                                })}
                                                                className="whitespace-nowrap px-3 py-4 text-sm text-gray-500"
                                                            >
                                                                {cell.render('Cell')}
                                                            </td>
                                                        );
                                                    })}
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                                <nav
                                    className="flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6"
                                    aria-label="Pagination"
                                >
                                    <div className="hidden sm:block">
                                        {!columns.some((col) => col.isSorted) && !state.globalFilter && page[0] ? (
                                            <p className="text-sm text-gray-700">
                                                Mostrando desde <span className="font-medium">{page[0].index + 1}</span>{' '}
                                                hasta{' '}
                                                <span className="font-medium">{page[page.length - 1].index + 1}</span>{' '}
                                                de un total de <span className="font-medium">{data.length}</span>{' '}
                                                resultados
                                            </p>
                                        ) : (
                                            <p className="text-sm text-gray-700">
                                                Página <span className="font-medium">{state.pageIndex + 1}</span> de{' '}
                                                <span className="font-medium">{pageCount}</span>
                                            </p>
                                        )}
                                    </div>
                                    <div className="flex flex-1 justify-between sm:justify-end">
                                        <select
                                            id="displayOptions"
                                            onChange={(e) => {
                                                setPageSize(Number(e.target.value));
                                            }}
                                            className="mr-4 relative inline-flex items-center rounded-md mx-1 w-32 border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50"
                                        >
                                            <option value="10">Mostrar 10</option>
                                            <option value="20">Mostrar 20</option>
                                            <option value="50">Mostrar 50</option>
                                        </select>
                                        <button
                                            type="button"
                                            onClick={() => previousPage()}
                                            disabled={!canPreviousPage}
                                            className="relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50"
                                        >
                                            Anterior
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => nextPage()}
                                            disabled={!canNextPage}
                                            className="relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50"
                                        >
                                            Siguiente
                                        </button>
                                    </div>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Transition appear show={isOpen} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={() => {}}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-25" />
                    </Transition.Child>

                    <div className="fixed inset-0 flex items-center justify-center">
                        <div className="bg-white p-6 rounded shadow-lg max-w-3xl w-full h-[80vh] overflow-hidden flex flex-col">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className="flex-grow flex flex-col overflow-hidden">
                                    <form
                                        onSubmit={handleAddOrUpdate}
                                        className="flex-grow flex flex-col overflow-hidden"
                                    >
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700">
                                                Título<span className="text-red-500">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                value={templateName}
                                                onChange={(e) => {
                                                    setTemplateName(e.target.value);
                                                    if (!e.target.value || e.target.value.trim() === '') {
                                                        setTemplateNameError(
                                                            'El nombre de la plantilla es obligatorio'
                                                        );
                                                    } else if (e.target.value.length < 3) {
                                                        setTemplateNameError(
                                                            'El nombre debe tener al menos 3 caracteres'
                                                        );
                                                    } else {
                                                        setTemplateNameError('');
                                                    }
                                                }}
                                                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                            />
                                            {templateNameError && (
                                                <p className="mt-1 text-sm text-red-500">{templateNameError}</p>
                                            )}
                                        </div>
                                        <div className="mt-4">
                                            <label className="block text-sm font-medium text-gray-700">
                                                Asunto<span className="text-red-500">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                value={templateSubject}
                                                onChange={(e) => {
                                                    setTemplateSubject(e.target.value);
                                                    if (!e.target.value || e.target.value.trim() === '') {
                                                        setTemplateSubjectError('El asunto del correo es obligatorio');
                                                    } else if (e.target.value.length < 3) {
                                                        setTemplateSubjectError('El asunto debe tener al menos 3 caracteres');
                                                    } else {
                                                        setTemplateSubjectError('');
                                                    }
                                                }}
                                                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                placeholder="Ingrese el asunto del correo electrónico"
                                            />
                                            {templateSubjectError && (
                                                <p className="mt-1 text-sm text-red-500">{templateSubjectError}</p>
                                            )}
                                        </div>
                                        <div className="mt-4 flex-grow flex flex-col overflow-hidden">
                                            <label className="mb-1 text-sm font-medium text-gray-700">Contenido</label>
                                            <div className="flex-grow overflow-y-auto border border-gray-300 rounded-md">
                                                {isSourceMode ? (
                                                    <textarea
                                                        value={editorContent}
                                                        onChange={(e) => setEditorContent(e.target.value)}
                                                        className="w-full h-full p-2 resize-none"
                                                    />
                                                ) : (
                                                    <div className="h-[500px] overflow-hidden flex flex-col">
                                                        <div className="flex-grow overflow-y-auto">
                                                            <JoditEditor
                                                                ref={editorRef}
                                                                value={editorContent}
                                                                config={config}
                                                                onBlur={(newContent) => setEditorContent(newContent)}
                                                            />
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="mt-4 flex justify-end space-x-2">
                                            <button
                                                type="button"
                                                className="px-4 py-2 bg-yellow-500 text-white rounded"
                                                onClick={toggleSourceMode}
                                            >
                                                {isSourceMode ? 'Modo nuevo' : 'Modo fuente'}
                                            </button>
                                            <button
                                                type="submit"
                                                className="px-4 py-2 bg-blue-500 text-white rounded"
                                                disabled={
                                                    !!templateNameError ||
                                                    !templateName.trim() ||
                                                    templateName.length < 3
                                                }
                                            >
                                                {currentTemplate !== null ? 'Update' : 'Add'}
                                            </button>
                                            <button
                                                type="button"
                                                className="px-4 py-2 bg-gray-500 text-white rounded"
                                                onClick={handleCancel}
                                            >
                                                Cancelar
                                            </button>
                                        </div>
                                    </form>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </WhiteCardContainer>
    );
};

export default EmailTemplates;
